import { render } from "./FeaturedCollection.vue?vue&type=template&id=62b085f0&scoped=true"
import script from "./FeaturedCollection.vue?vue&type=script&lang=js"
export * from "./FeaturedCollection.vue?vue&type=script&lang=js"

import "./FeaturedCollection.vue?vue&type=style&index=0&id=62b085f0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b085f0"]])

export default __exports__